import { get } from './Object';

const INPUT_NODE_NAME = 'INPUT';

const KEYS = {
  ENTER: {
    NAME: 'Enter',
    CODE: 13
  },
  ESC: {
    NAME: 'Escape',
    CODE: 27
  }
};

const isTargetInput = (event) => {
  if (event && event.target) {
    return event.target.nodeName === INPUT_NODE_NAME;
  }

  return false;
};

const compareKeyDown = (event, { NAME, CODE }) =>
  event && (event.key === NAME || event.keyCode === CODE);

const isKeyDownEnter = (event) => compareKeyDown(event, KEYS.ENTER);

const isKeyDownEsc = (event) => compareKeyDown(event, KEYS.ESC);

const getChangeEvent = (name, value) => ({
  target: {
    name,
    value
  }
});

const getEventValue = (event) => get(event, 'target.value', null);

const getSelectEventValue = (event) => get(event, 'target.value.value', null);

export {
  isTargetInput,
  isKeyDownEnter,
  isKeyDownEsc,
  INPUT_NODE_NAME,
  KEYS,
  getChangeEvent,
  getSelectEventValue,
  getEventValue
};
